// extracted by mini-css-extract-plugin
export default {"prompt":"SignInPrompt_prompt__Gv088"};